import React from "react";
import "./TableTitle.css";

const TableTitle = ({ title }) => {
  return <span className="table-title">{title}</span>;
};

export default TableTitle;
